import { PageWrapTemplate } from '../../componentsF/PageTemplateF.jsx'
import { Ptext } from '../../componentsF/Chakra3F/ChakraF.jsx'
import { PubEnvWrapper } from '../../componentsF/PubEnvWrapF.jsx'
import { PtSiteWrap } from '../../componentsF/PtSiteWrapF.jsx'
import { NoSSRWrapper } from '../../componentsF/NoSSRWrapperF.jsx'
import { PageSkeleton } from '../componentsF/LoadingCtxAI.jsx'

const App = ({Component, pageProps}) => {
  const value = {
    LoadingComp: PageSkeleton,
    fmtSiteError: ({error}) => {
      return <Ptext {...{fontSize: '3xl', textAlign: 'center', my: 20}}>
        Error {error?.message}<br />Please try refreshing this page
      </Ptext>
    },
  }
  return <PtSiteWrap {...{value}}>
    <PageWrapTemplate {...{initialColorMode: 'dark'}}>
      <NoSSRWrapper>
        <PubEnvWrapper {...{isQuiet: true}}>
          <Component {...pageProps} />
        </PubEnvWrapper>
      </NoSSRWrapper>
    </PageWrapTemplate>
  </PtSiteWrap>
}
export default App
